var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircleSolidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "info-circle-solid-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info-circle-solid-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m.167 3.333a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1.5 9H7A.667.667 0 1 1 7 11h.5a.167.167 0 0 0 .167-.167v-3a.167.167 0 0 0-.167-.166H7a.667.667 0 1 1 0-1.334h.667A1.333 1.333 0 0 1 9 7.666v3.167a.167.167 0 0 0 .167.167h.5a.667.667 0 1 1 0 1.333"
}))));
export { SvgInfoCircleSolidIcon as ReactComponent };
export default __webpack_public_path__ + "6e8f66c8145097c358b2c28c3c2d1ab1.svg";